/**
 * FAQs
 */

const faqQuestions = document.querySelectorAll('.c-faqs__question')

faqQuestions.forEach(faq => {
  const faqAnswer = faq.nextElementSibling
  const faqAnswerHeight = faqAnswer.clientHeight
  faqAnswer.style.overflow = 'hidden'
  faqAnswer.style.transition = '.4s'
  faqAnswer.style.height = `${faqAnswerHeight}px`

  faq.addEventListener('click', () => {
    if (faq.getAttribute("aria-expanded") === 'false') {
      faq.setAttribute('aria-expanded', true)
      faq.classList.add('is-active')
      faqAnswer.style.height = `${faqAnswerHeight}px`
    } else {
      faq.setAttribute('aria-expanded', false)
      faq.classList.remove('is-active')
      faqAnswer.style.height = '0'
    }
  })
})